module.exports = __webpack_public_path__ + "img/draw.11ef6462.png";